module.exports = __webpack_public_path__ + "static/main_logo_mobile-5d5a0949ae554c7724f349422f9f27a3.svg";